<template lang='pug'>
  //-
    @file 根据模型生成表单
    @author 李小龙
    @date 2018/5/31
  .model-inputs
    el-form-item(v-if='hasProjectTree' label='项目')
      project-select(:form='form')
    el-form-item(v-for='attr in myModel' :label='attr.label' :key='attr.prop' v-if='!attr.tableOnly && ((isInsert && !attr.hideInInsert)||(isEdit && !attr.hideInEdit)||(isInfo && !attr.hideInInfo)||(!isInsert&&!isEdit&&!isInfo)) && (!attr.inputCondition || attr.inputCondition(form))' :required='attr.required' :prop='attr.prop' :show-message='!isInfo')
      .el-input.is-disabled(v-if='attr.type=="text" && ((attr.disableEdit && isEdit) || isInfo || attr.disableAttr)')
        .el-input__inner(v-text='attr.formatter?attr.formatter(form, attr.prop, form[attr.prop]):form[attr.prop]')
      el-input(v-if='attr.type=="text" && !((attr.disableEdit && isEdit) || isInfo || attr.disableAttr)' v-model='form[attr.prop]' :maxlength='attr.maxLength' :placeholder='attr.placeholder')
      el-autocomplete(v-if='attr.type=="autocomplete"' v-model='form[attr.prop]' :fetch-suggestions='attr.fetchSuggestions' :maxlength='attr.maxLength' :disabled='(attr.disableEdit && isEdit) || isInfo' :placeholder='attr.placeholder')
      el-input(v-if='attr.type=="password"' type='password' v-model='form[attr.prop]' :maxlength='attr.maxLength' :disabled='(attr.disableEdit && isEdit) || isInfo' :placeholder='attr.placeholder')
      el-input(v-if='attr.type=="readonly"' v-model='form[attr.prop]' disabled :placeholder='attr.placeholder')
      el-date-picker(v-if='attr.type=="date"' v-model='form[attr.prop]' :placeholder="attr.placeholder || '选择日期'" value-format='yyyy-MM-dd' :picker-options='{disabledDate: attr.disabledDate}' :disabled='(attr.disableEdit && isEdit) || isInfo')
      el-time-picker(v-if='attr.type=="time"' v-model='form[attr.prop]' placeholder="选择时间" value-format='HH:mm' format='HH:mm' :disabled='(attr.disableEdit && isEdit) || isInfo')
      el-date-picker(v-if='attr.type=="datetime"' type='datetime' v-model='form[attr.prop]' placeholder="选择时间" value-format='yyyy-MM-dd HH:mm:ss' :disabled='(attr.disableEdit && isEdit) || isInfo')
      el-date-picker(v-if='attr.type=="month"' type='month' v-model='form[attr.prop]' placeholder="选择时间" value-format='yyyy-MM' :disabled='(attr.disableEdit && isEdit) || isInfo')
      el-input(v-if='attr.type=="textarea"' v-model='form[attr.prop]' type='textarea' :rows='3' :maxlength='attr.maxLength')
      el-input(v-if='attr.type=="url"' v-model="form[attr.prop]" placeholder="请输入完整链接地址")
      radio-input(v-if='attr.type=="radioInput"' v-model='form[attr.prop]' :roleTypeChecked="form.roleType")
      el-select(v-if='attr.type=="select"' :disabled='isInfo' v-model='form[attr.prop]' filterable placeholder="请选择" :filterable='attr.filterable')
        el-option(v-if='attr.emptyOption' :label='attr.emptyOption' value='')
        el-option(v-for='(value, key) in attr.mapper' :key='key' :label='value' :value='Number(key)')
      el-radio-group(v-if='attr.type=="radio"' v-model='form[attr.prop]')
        el-radio(v-for='(value, key) in attr.mapper' :key='value' :label='Number(key)') {{value}}
      el-select(v-if='attr.type=="bool"' v-model='form[attr.prop]' filterable placeholder="请选择")
        el-option(v-for='(value, key) in attr.mapper' :key='key' :label='value' :value='String(key)')
      el-input-number(v-if='attr.type=="natural"' v-model='form[attr.prop]' :min='0')
      el-input(v-if='attr.type=="number"' v-model='form[attr.prop]' :maxlength='attr.maxLength' type='number')
      file-input(v-if='attr.type=="image" || attr.type=="video" || attr.type=="apk"' v-model='form[attr.prop]' :type='attr.type' :disabled='(attr.disableEdit && isEdit) || isInfo' :text='attr.text' @first-file-time='$emit("first-file-time", $event)')
      multi-image-input(:disabled='isInfo' v-if='attr.type=="multi-image"' v-model='form[attr.prop]' @first-file-time='$emit("first-file-time", $event)')
      model-table(v-if='attr.type == "table"' :model-src='attr.tableModelSrc' :data='form[attr.prop]' has-index)
</template>

<script>
import FileInput from './file-input'
import ProjectSelect from './project-select'
import Model from 'crud-model-class'
import {ModelTable} from 'bird-ui'
import MultiImageInput from './multi-image-input'
import radioInput from './radio-input'

export default {
  components: {
    FileInput,
    ProjectSelect,
    ModelTable,
    MultiImageInput,
    radioInput,
  },
  computed: {
    myModel() {
      return this.model || new Model(this.modelSrc)
    },
    staffBtnStyle() {
      return ['primary', 'medium', this.form.userName || '请选择']
    }
  },
  props: {
    form: Object,
    hasProjectTree: Boolean, //是否有企业项目树单选弹框作为第一个表单
    isInsert: Boolean,
    isEdit: Boolean,
    isInfo: Boolean,
    model: Array,
    modelSrc: Object,
  },
  mounted() {
    for (var attr of this.myModel) {
      if (attr.tableOnly) continue
      if (!(attr.prop in this.form)) {
        this.$set(this.form, attr.prop)
      }
    }
  },
  methods: {
    setStaff(data, prop) {
      this.form[prop] = data.currentUser.id
      this.$set(this.form, 'userName', data.currentUser.name)
      this.form.departmentId = data.currentUser.departmentId
    },
  }
}
</script>

<style lang='stylus' scoped>
.el-input, .el-select, .el-textarea, .el-input-number, .el-range-editor, .el-autocomplete
  width 100%
.el-input__inner
  line-height 32px
  min-width 200px
</style>



// WEBPACK FOOTER //
// src/components/model-inputs.vue